import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  root: {
    '& .MuiPaper-root': {
      width: `${spacing(820)} !important`,
      maxWidth: 'none !important',
      overflowX: 'hidden',
      boxSizing: 'border-box',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: spacing(10),
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '20px 170px 170px 2fr 80px',
    alignItems: 'flex-end',
    columnGap: '2rem',
  },
  checkContainer: {
    width: '20px',
    marginBottom: spacing(4),
  },
  iconsContainer: {
    display: 'flex',
    gap: 2,
    marginBottom: spacing(2),
  },

  compactAutocomplete: {
    '& .MuiInputBase-root': {
      alignItems: 'flex-end',
      minHeight: '26px !important',
    },
    '& .MuiInputBase-input': {
      fontSize: spacing(14),
      paddingBottom: '0 !important',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child': {
      paddingBottom: '0 !important',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(0, -0.5px) scale(1)',
      fontSize: 14,
      color: Theme.Colors.Grayscale.Eighty,
    },
  },
  fieldOverlayWrapper: {
    position: 'relative',
    width: '100%',
  },
  clickBlockOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    cursor: 'pointer',
  },

  label: {
    fontSize: spacing(14),
    color: Theme.Colors.Grayscale.Eighty,
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
  },
}))
